import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import { observer } from 'mobx-react';

import { Label } from 'core/components/label';
import { useStore } from 'core/store/store.mobx';

// #35249: a matching active policy no longer hard-blocks a bind. A named insured can legitimately
// hold several policies (Home, Farm, Rental at different locations), so we warn and let the agent
// proceed intentionally — or catch a genuine duplicate — before finalizing.
const MatchingActivePolicyWarning = observer(({ classes }) => {
  const { offer: store } = useStore();
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);

  const ids = store.matchingActivePolicyIds?.slice() ?? [];

  const onConfirm = async () => {
    setSubmitting(true);
    const { id, systemId } = await store.confirmMatchingActivePolicyBind();
    setSubmitting(false);
    if (id && systemId) {
      history.push(`/offer/${store.offer.id}/purchased`);
    }
  };

  const onCancel = () => {
    store.cancelMatchingActivePolicyWarning();
  };

  return (
    <>
      <Label type="titleSecondary" className={classes.title}>
        This member already has an active policy
      </Label>
      <Label type="infoValue" className={classes.errorMessage}>
        {ids.length
          ? `An active policy (${ids.join(', ')}) already exists for this named insured at this property. ` +
            'A member can hold more than one policy, so this may be intentional — confirm you want to purchase ' +
            'this one anyway, or cancel to review.'
          : 'An active policy already exists for this named insured at this property. A member can hold more ' +
            'than one policy, so this may be intentional — confirm you want to purchase this one anyway, or ' +
            'cancel to review.'}
      </Label>
      <Grid container justifyContent="flex-end" className={classes.bottom}>
        <Button onClick={onCancel} variant="outlined" color="primary" className={classes.btn} disabled={submitting}>
          <Label className={classes.btnLabel}>Cancel</Label>
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary" className={classes.btn} disabled={submitting}>
          <Label className={classes.btnLabel}>Purchase anyway</Label>
        </Button>
      </Grid>
    </>
  );
});

MatchingActivePolicyWarning.propTypes = {
  classes: PropTypes.object.isRequired
};

export default MatchingActivePolicyWarning;
